import { IRestriction } from "..";

export interface ISingleSelectableConditionallyAsynchronously<T, TCondition> {
  selectOptionConditionally(condition: TCondition, defaultOption?: T, restrictions?: { [key: string]: IRestriction }): Promise<T>;
}

export function instanceOfISingleSelectableConditionallyAsynchronously<T, TCondition>(instance: any): instance is ISingleSelectableConditionallyAsynchronously<T, TCondition> {
  return instance && (instance.selectOptionConditionally !== undefined);
}
